@if (!entry || entry.base?.display) {
  <div>
    <div class="instructions-list-header">
      <p>Instructions for uploading your files</p>
    </div>
    <ul class="instructions-list">
      @if (customConfigs.minDocuments) {
        <li>A minimum of <strong>{{this.customConfigs.minDocuments}}</strong> document{{this.customConfigs.minDocuments > 1 ? 's' : ''}} must be uploaded</li>
      }
      <li>A maximum of <strong>{{maxUploadFileNumber}}</strong> document{{maxUploadFileNumber > 1 ? 's' : ''}} can be uploaded</li>
      <li>Single file size limit is <strong>{{fileSizeLimitInMB}}</strong> MB</li>
      <li>Click the <strong>"Upload" button</strong> to upload individual files</li>
      @if (customConfigs?.fifthBullet) {
        <span [innerHTML]="customConfigs?.fifthBullet"></span>
      }
    </ul>
    <!-- TABLE DISPLAY -->
    @if (fileDisplayArray && fileDisplayArray.length) {
    <div class="file-table">
      <table>
        <!-- HEADER -->
        <thead>
          <tr>
            @for (header of displayedColumns; track $index; let i = $index) {
              <th class="header-cell">{{header}}</th>
            }
          </tr>
        </thead>
        <!-- BODY -->
        <tbody>
          <!-- FILE LIST -->
          @for (
            fileObj of fileDisplayArray; track trackByIndexNameSize(i,
            fileObj); let i = $index) {
            <tr [app-file-display]
              #FileDisplayComponent
              [displayableFileObj]="fileObj"
              [actualFileObj]="fileListArray[i]"
              [index]="i"
              [allowedExtensions]="allowedExtensions"
              [fileSizeLimitInMB]="fileSizeLimitInMB"
              [canUploadMoreFiles]="canUploadMoreFiles"
              [customPayloadAdditions]="addPayloadAdditions()"
              [onUploadFile]="onUploadFile()"
              [onRemoveFile]="onRemoveFile()"
              [disableRemoveButtonOnSuccess]="customConfig?.disableRemoveButtonOnSuccess"
              >
            </tr>
          }
          <!-- ADDITIONAL FILES / UPLOAD ALL / REMOVE ALL -->
          <tr>
            <!-- ADD FILES -->
            <td [attr.colspan]="'2'">
              <!-- DISPLAY: NONE -->
              <input #hiddenfileinput_additional
                style="display: none;"
                type="file"
                id="file"
                class="file-input"
                [accept]="allowedExtensionsAsString"
                (change)="onHandleFileInput($event, $event.target.files)" />
                <!-- Accepted file types: .doc, .docx, .xls, .xlsx, .txt, .rtf, .png, .jpg, .tif, .bmp, .ppt, .pptx, .pdf -->
                <!-- DISPLAY: VISIBLE -->
                <button mat-raised-button color="accent" [disabled]="!canAddMoreFiles" (click)="hiddenfileinput_additional.click()">
                  Add Another File
                </button>
              </td>
              <!-- Filler Columns -->
              <!-- UPLOAD ALL -->
              <td>
                @if (fileListArray) {
                  <button
                    mat-raised-button
                    class="handle-all-files-button"
                    color="primary"
                    [ngClass]="{
                      'interactable': canUploadMoreFiles,
                      'disabled': !canUploadMoreFiles
                    }"
                    [disabled]="disabledUploadDueToDropdownLogic"
                    (click)="uploadAllFiles()"
                    >
                    Upload All
                  </button>
                }
              </td>
              <!-- REMOVE ALL -->
              <td>
                @if (fileListArray && fileListArray.length > 1) {
                  <button mat-raised-button class="handle-all-files-button" (click)="removeAllFiles()">
                    Remove All
                  </button>
                }
              </td>
            </tr>
          </tbody>
        </table>
      </div>
      } @else {
        <!-- DISPLAY: NONE -->
        <input #hiddenfileinput_initial
          style="display: none;"
          type="file"
          id="file"
          class="file-input"
          [accept]="allowedExtensionsAsString"
          (change)="onHandleFileInput($event, $event.target.files)" />
          <!-- Accepted file types: .doc, .docx, .xls, .xlsx, .txt, .rtf, .png, .jpg, .tif, .bmp, .ppt, .pptx, .pdf -->
          <!-- DISPLAY: VISIBLE -->
          <button class="file-upload-button" mat-raised-button color="primary" (click)="hiddenfileinput_initial.click()">
            File Upload
          </button>
        }
        <!-- FIRST-TIME BUTTON -->
      </div>
    }
